export type Attributes<T extends keyof HTMLElementTagNameMap> = Omit<
  Partial<HTMLElementTagNameMap[T]>,
  'style'
> & {
  style?: string;
};

/** @internal too be called by jsxFactory only */
export default <T extends keyof HTMLElementTagNameMap>(
  tag: T,
  props: Attributes<T> | null,
  ...children: (string | HTMLElement)[]
) => {
  const element = document.createElement(tag);

  Object.entries(props || {}).forEach(([key, value]) => {
    const castKey = key as keyof HTMLElementTagNameMap[T];

    if (typeof castKey === 'string' && castKey.includes('data-')) {
      element.dataset[castKey.replace('data-', '')] = value as string;
    } else if (
      typeof castKey === 'string' &&
      ![
        'className',
        'style',
        'onload',
        'onerror',
        'onclick',
        'onchange',
        'oninput',
      ].includes(castKey)
    ) {
      // Use setAttributeNS for custom elements to preserve unknown attributes (and maintain casing)
      element.setAttributeNS(null, key, value as string);
    } else {
      // Since we're replacing the style attribute this complains heaps
      // @ts-ignore
      element[castKey] = value;
    }
  });

  if (Array.isArray(children)) {
    children.forEach((child) => {
      element.append(child);
    });
  } else {
    element.append(children);
  }

  return element;
};
